module.exports = new __parcel__URL__("magnifying_glass.f802f9ab.svg").toString();